import { FormModel } from 'components/Form';
import { Validators } from 'utils/validators';

interface DropdownProps {
  label: string;
  value: any;
}

export const SendCorporateRateForm = (
  strings: any,
  contacts: DropdownProps[],
  mappedOrganizations: DropdownProps[],
): FormModel[] => {
  const formFields: FormModel[] = [
    {
      label: strings.beo_to_email_text,
      value: '',
      autoFocus: true,
      type: 'select',
      isClearable: true,
      isMulti: true,
      variant: 'outlined',
      placeholder: strings.beo_to_email_text,
      field: 'to',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      size: 'medium',
      options: contacts,
      disabled: false,
      required: true,
    },
  ];

  if (mappedOrganizations.length > 1) {
    formFields.push({
      label: strings.organization_dropdown_placeholder_text,
      value: [],
      type: 'select',
      isClearable: true,
      isMulti: false,
      variant: 'outlined',
      placeholder: strings.organization_dropdown_placeholder_text,
      field: 'organization',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      size: 'medium',
      options: mappedOrganizations,
      disabled: false,
      required: true,
    });
  }

  formFields.push(
    {
      label: strings.beo_cc_email_text,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'cc',
      validators: [{ check: Validators.validateEmailList }],
      responsive: { xs: 12 },
      required: false,
      multiline: true,
      minRows: 1,
      maxRows: 3,
    },
    {
      label: strings.beo_bcc_email_text,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'bcc',
      validators: [{ check: Validators.validateEmailList }],
      responsive: { xs: 12 },
      required: false,
      multiline: true,
      minRows: 1,
      maxRows: 3,
    },
    {
      label: strings.paymentDetails_text_attachment,
      value: [],
      type: 'upload',
      placeholder: '',
      field: 'attachments',
      validators: [],
      responsive: { xs: 12 },
      accept: '',
      required: false,
    },
  );

  return formFields;
};
